// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"9fe64d59","329":"ae24a134","349":"cee28863","699":"517359d0"}[chunkId] + ".chunk.js";
};